<mat-form-field appearance="outline" [floatLabel]="'always'">
    <mat-label>
        <ng-content select="aum-form-field-label"></ng-content>
    </mat-label>
    <number-input
        #theNumberInput
        [placeholder]="placeholder"
        [formControl]="control"
        [disabled]="disabled"
        [required]="required"
        [allowNegative]="allowNegative"
        [decimalPlaces]="decimalPlaces"
        [errorStateMatcher]="errorStateMatcher"
    ></number-input>
    <mat-error>
        <ng-content select="aum-form-error"></ng-content>
    </mat-error>
</mat-form-field>
